import { TileLayer, BitmapLayer, ScatterplotLayer, GeoJsonLayer } from 'deck.gl';
import GL from '@luma.gl/constants';

import { geojsonIndex  } from './geojsonIndex.js'


const mapbox_tile_URL =
  "https://api.mapbox.com/styles/v1/mapbox/dark-v10/tiles/512/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic2hpbWl6dSIsImEiOiJjbGZwbDg3YnUwYWV2M3FubDdvN3pqcDhxIn0.WfKF0oFWPFqS6xn0Mm0Yow"


export function renderLayers({ sliderValue }) {
  let layers = []
 


  const tileLayer = new TileLayer({
    id: "tile-layer",
    data: mapbox_tile_URL,
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });

  layers.push(tileLayer)


  const dataset = (sliderValue > 0) ? [geojsonIndex[sliderValue], geojsonIndex[sliderValue - 1]] : [geojsonIndex[sliderValue]];

  //console.log("dataset", dataset)
  
  //geojsonIndex.filter((d, i) => i <= sliderValue)
  
  if (geojsonIndex[sliderValue].label === "2023"){
    const d = geojsonIndex[sliderValue]
    const maebashi = new GeoJsonLayer({
      id: "geojson_maebashi" + d.label,
      data: d.maebashi,
      stroke: true,
      lineWidthMinPixels: 2,
      getFillColor: [180, 0, 0, 180],
      getLineColor: [120, 0, 0, 255],
    })

    const takasaki = new GeoJsonLayer({
      id: "geojson_takasaki" + d.label,
      data: d.takasaki,
      stroke: true,
      lineWidthMinPixels: 2,
      getFillColor: [0, 0, 180, 180],
      getLineColor: [0, 0, 120, 255],
    })

    layers.push(maebashi);
    layers.push(takasaki);


  }else{
    dataset.forEach(d => {
      

      const maebashi = new GeoJsonLayer({
        id: "geojson_maebashi" + d.label,
        data: d.maebashi,
        stroke: true,
        lineWidthMinPixels: 2,
        getFillColor: [120, 0, 0, 160],
        getLineColor: [120, 0, 0, 255],
      })

      const takasaki = new GeoJsonLayer({
        id: "geojson_takasaki" + d.label,
        data: d.takasaki,
        stroke: true,
        lineWidthMinPixels: 2,
        getFillColor: [0, 0, 120, 160],
        getLineColor: [0, 0, 120, 255],
      })

      layers.push(maebashi);
      layers.push(takasaki);


    })

  }

  //OSMタイルを読み込みベースマップとして表示


  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return layers;
}
